//noScroll
class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){


  const mvAnimation = () => {
    let tl = gsap.timeline({repeat: 0, repeatDelay: 0.2});
    const num = 0.6

    tl.fromTo(".mv-left__swiper-01", 3 * num,
      {
        autoAlpha: 0,


      }, {
        autoAlpha:1,

      }
    );
    tl.fromTo('.mv-left__swiper-04', 3 * num, {
      autoAlpha: 0,
    },
    {
      autoAlpha:1,
    },
    `-=${3 * num}`
    );
    tl.fromTo(".mv-left__swiper-02", 2 * num,
      {
        autoAlpha: 0,


      }, {
        autoAlpha:1,

      },
      `-=${2 * num}`
    );
    tl.fromTo('.mv-left__swiper-05', 2 * num, {
      autoAlpha: 0,
    },
    {
      autoAlpha:1,
    },
    `-=${2 * num}`
    );
    tl.fromTo(".mv-left__swiper-03", 1 * num,
      {
        autoAlpha: 0,


      }, {
        autoAlpha:1,

      },
      `-=${num}`
    );
    tl.fromTo('.mv-left__swiper-06', num, {
      autoAlpha: 0,
    },
    {
      autoAlpha:1,
    },
    `-=${num}`
    );
    tl.fromTo('.js-mv-swiper', 3 * num, {
      autoAlpha: 0,
    },
    {
      autoAlpha:1,
    },
    `-=${3 * num}`
    );
    tl.fromTo(".js-mv-ttl", 1.6 * num,
    {
      autoAlpha: 0,
    }, {
      autoAlpha:1,
    },
    `-=${0.3 * num}`
  );


  }

  const topSwiper = () => {

    /****************************************
    MVスライダー 右画像
   ****************************************/

    // const swiperMv = new Swiper(".mv-swiper", {
    //   loop: true,
    //   slidesPerView: "auto",
    //   speed: 1000,
    //   allowTouchMove: false,
    //   autoplay: {
    //     delay: 4000,
    //   },
    // });

    for (let i = 1; i <= 6; i++) {
      var random = Math.floor( Math.random() * (10 - 1) ) + 1 * i;

      setTimeout(() => {
        const swiperSlideMv = new Swiper(`.mv-left__swiper-0${i}`, {

          effect: 'fade',
          loop: true,
          slidesPerView: "auto",
          speed: 1500,
          allowTouchMove: false,
          // effect: 'fade',
          autoplay: {
            delay: 2500,
          },
        });
      }, random * i * 120 - 3 );


    }



    const mvEnvSwiper = new Swiper(".env-swiper", {
      loop: true,
      slidesPerView: "auto",
      speed: 1000,
      allowTouchMove: false,
      centeredSlides : true,
    });

    if (window.matchMedia('(max-width: 768px)').matches) {
      const memberSwiper = new Swiper(".member-swiper", {
        loop: true,
        slidesPerView: "auto",
        speed: 1000,
        spaceBetween: 24,
        // allowTouchMove: false,

        // centeredSlides : true,
        autoplay: {
          delay: 4000,
        },
        pagination: {
          el: ".swiper-pagination", // ページネーションのクラス名を指定
          type: "fraction", // ページネーションのtypeを指定
          formatFractionCurrent: function (number) {
            return '0' + number;
        },
        formatFractionTotal: function (number) {
          return ('0' + number).slice(-2); // 先頭に0をつける、二桁表示
        },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    }
  }

  const topMsgScroll = () => {

    const msgBg = document.querySelector(".msg-bg")
    let percentage = 0

    gsap.to(msgBg,
    {
      scrollTrigger: {
        trigger: '.js-msg-scroll',
        pin: true, // trigger要素を固定
        scrub: true,
        ease:'none',
        start: 'top',
        end:'bottom+=100 top',
        onUpdate:(self)=>{

          if(percentage < 100){
            percentage = self.progress.toLocaleString( undefined, { maximumFractionDigits:3 })*100;


            if (window.matchMedia('(min-width: 1600px)').matches) {
              if((96 + 50 / 100 * percentage) / 120 <= 1.01){
                msgBg.style.transform = `scale(calc((96 + 50 / 100 * ${percentage}) / 120))`
                msgBg.style.maxHeight = "1000px"
              }
            }else{
              if((96 + 50 / 100 * percentage) / 120 <= 1.03){
                msgBg.style.transform = `scale(calc((96 + 50 / 100 * ${percentage}) / 120))`
              }
            }


          }
        },
        onLeave: () => {
          msgBg.style.transform = `scale(1.02)`
        },
        // markers:true,
      }
    });
  }

  const getRandomInt = (min, max) => {
    return Math.floor(Math.random() * (max - min) + min);
  }

  const ScrollAnimation = {
    instance: undefined,
    set() {
      this.instance = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if(entry.isIntersecting) {
              entry.target.classList.add('is-active');
            }
          });
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 0,
        }
      );

      const blocks = document.querySelectorAll('.title');
      blocks.forEach((block) => {
        this.instance.observe(block);
      });
    },
  };

  const SplitText = (target) => {
    const splitElm = document.querySelectorAll(target);
    splitElm.forEach((el, index) => {
      let text = el.textContent;
      el.textContent = '';
      text = text.split('');
      let newText = '';
      text.forEach((t, index) => {
        newText += `<span class="word" data-random="${getRandomInt(1, 8)}">${t}</span>`;
      });
      el.insertAdjacentHTML('beforeend', newText);
    });
  };

  const memberHov = () => {
    const members = document.querySelectorAll(".js-member-hov")

    members.forEach( (member, i) => {
      member.addEventListener("mouseover", () => {
        member.classList.add("is-active")
      })
      member.addEventListener("mouseleave", () => {
        member.classList.remove("is-active")
      })
    });
  }


  SplitText('.text-split');
  ScrollAnimation.set();

  mvAnimation()


  setTimeout(() => {
    topSwiper()
  }, 300);

  if (window.matchMedia('(min-width: 768px)').matches) {
    topMsgScroll()
    memberHov()
  }

  const breakpoint = window.matchMedia("(max-width:768px)");

  breakpoint.addEventListener("change", () => {
    window.location.reload();
  });

  // memberModal();


  }


}
